import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Helper function to extract readable file type
const getFileType = (file) => {
    // First, try to extract from filename if availabel
    if (file.filename) {
        const extension = file.filename.split('.').pop()?.toUpperCase();
        if (extension)
            return extension;
    }
    // Fallback: parse the subtype
    const subtype = file?.subtype ? file.subtype.toLowerCase() : '';
    // Handle simple cases like "pdf"
    if (subtype === 'pdf')
        return subtype.toUpperCase();
    // Handle Office document MIME types
    if (subtype.includes('presentationml'))
        return 'PPTX';
    if (subtype.includes('spreadsheetml'))
        return 'XLSX';
    if (subtype.includes('wordprocessingml'))
        return 'DOCX';
    // Extract extension from complex MIME subtypes
    // e.g., "vnd.openxmlformats-officedocument.presentationml.presentation" -> "presentation"
    const parts = subtype.split('.'), lastPart = parts[parts.length - 1];
    // Map common MIME types to readable formats
    const mimeTypeMap = {
        'presentation': 'PPTX',
        'sheet': 'XLSX',
        'document': 'DOCX'
    };
    if (mimeTypeMap[lastPart]) {
        return mimeTypeMap[lastPart];
    }
    // Last resort: return the last part capitalized
    return lastPart.toUpperCase();
};
const Document = ({ id, title, description, file }) => {
    const fileType = getFileType(file);
    return (_jsxs("div", { className: "document", children: [_jsxs("div", { children: [_jsx("h5", { className: "mb-4", children: title }), _jsx("div", { dangerouslySetInnerHTML: { __html: description } })] }), file && (_jsxs("a", { href: file.url, target: "_blank", className: "btn btn--outline flex-none", children: ["Download ", fileType, _jsx("i", { className: "far fa-file-download" })] }))] }));
};
export default Document;
